import EN from './en.json';
import SE from './se.json';

export default {
  en: { ...EN },
  se: { ...SE }
};
